import eventLogQueue from './eventLogQueue.js'
import proctoringGlitchRefresh from './proctoringGlitchRefresh.js'

const BROWSER_ENROLLMENT_RESUME_TTL_MS = 30 * 1000

const clearExitedForSlug = slug => {
    if (!slug) return false
    if (typeof localStorage === 'undefined') return false

    try {
        const raw = localStorage.getItem('exited')
        if (!raw) return false

        const parsed = JSON.parse(raw)
        const hasValidShape =
            parsed && typeof parsed === 'object' && !Array.isArray(parsed)

        if (!hasValidShape || typeof parsed.slug !== 'string') {
            localStorage.removeItem('exited')
            return true
        }

        if (parsed.slug !== slug) return false

        localStorage.removeItem('exited')
        return true
    } catch {
        try {
            localStorage.removeItem('exited')
            return true
        } catch {
            return false
        }
    }
}

const writeExitState = ({ slug, attemptId, isEnrolled = false } = {}) => {
    if (!slug) return false

    try {
        localStorage.setItem(
            'exited',
            JSON.stringify({
                slug,
                datetime: new Date().toISOString(),
                attemptId: String(attemptId || ''),
                isEnrolled: isEnrolled === true,
            })
        )
        return true
    } catch {
        return false
    }
}

const hasActiveViolation = ({ locationState, slug } = {}) => {
    if (locationState?.isPlagiarism === true) return true

    try {
        const raw = localStorage.getItem('violation_detected')
        if (!raw) return false

        const parsed = JSON.parse(raw)
        return Boolean(
            slug &&
                parsed &&
                typeof parsed === 'object' &&
                !Array.isArray(parsed) &&
                parsed.slug === slug
        )
    } catch {
        return false
    }
}

const readBrowserEnrollmentResumeSnapshot = ({
    attemptId,
    assessmentSlug,
    now = Date.now(),
} = {}) => {
    let exited
    try {
        exited = JSON.parse(localStorage.getItem('exited'))
    } catch {
        clearExitedForSlug(assessmentSlug)
        return null
    }

    const exitedAt = Date.parse(exited?.datetime)
    const isValid =
        Boolean(attemptId) &&
        Boolean(assessmentSlug) &&
        exited?.slug === assessmentSlug &&
        exited.attemptId === String(attemptId) &&
        exited.isEnrolled === true &&
        Number.isFinite(exitedAt) &&
        exitedAt <= now &&
        now - exitedAt < BROWSER_ENROLLMENT_RESUME_TTL_MS

    return isValid ? exited : null
}

const clearSharedAttemptStorageAfterClose = ({
    slug,
    attemptId,
    clearViolationDetected = true,
} = {}) => {
    if (slug) {
        clearExitedForSlug(slug)
        proctoringGlitchRefresh.clearForSlug(slug)
    }

    if (clearViolationDetected) {
        try {
            const raw = localStorage.getItem('violation_detected')
            if (raw) {
                try {
                    const parsed = JSON.parse(raw)
                    const hasDifferentSlug =
                        parsed &&
                        typeof parsed === 'object' &&
                        !Array.isArray(parsed) &&
                        typeof parsed.slug === 'string' &&
                        slug &&
                        parsed.slug !== slug

                    if (!hasDifferentSlug) {
                        localStorage.removeItem('violation_detected')
                    }
                } catch {
                    localStorage.removeItem('violation_detected')
                }
            }
        } catch {
            /* ignore */
        }
    }

    if (attemptId) {
        eventLogQueue.clear(attemptId)
    }
}

export {
    BROWSER_ENROLLMENT_RESUME_TTL_MS,
    clearExitedForSlug,
    clearSharedAttemptStorageAfterClose,
    hasActiveViolation,
    readBrowserEnrollmentResumeSnapshot,
    writeExitState,
}
